import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AttachmentInputComponent } from './attachment-input/attachment-input.component';
import { AttachmentListComponent } from './attachment-list/attachment-list.component';
import { AttachmentComponent } from './attachment.component';
import { AttachmentService } from './attachment.service';
import { MultiAttachmentComponent } from './multi-attachment.component';

let options: any = {
  autoDismiss: true,
  positionClass: 'toast-bottom-right',
};

@NgModule({
  declarations: [
    MultiAttachmentComponent,
    AttachmentComponent,
    AttachmentListComponent,
    AttachmentInputComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule,
    FormsModule
  ],
  exports: [
    MultiAttachmentComponent,
    AttachmentComponent,
    AttachmentListComponent,
    AttachmentInputComponent
  ],
  providers: [
    AttachmentService,
  ]
})

export class AttachmentModule { }
